scratchblocks.loadLanguages({
  "nb": {
    "commands": {
      "turn %m.motor on": "start %m.motor", 
      "show": "vis", 
      "switch backdrop to %m.backdrop and wait": "bytt bakgrunn til %m.backdrop og vent", 
      "repeat until %b": "gjenta til %b", 
      "play note %d.note for %n beats": "spill tone %d.note i %n takter", 
      "show variable %m.var": "vis variablen %m.var", 
      "turn %m.motor off": "stopp %m.motor", 
      "set pen color to %c": "velg pennfarge %c", 
      "set pen color to %n": "velg pennfarge %n", 
      "change %m.effect effect by %n": "endre %m.effect effekt med %n", 
      "say %s": "si %s", 
      "go to x:%n y:%n": "gå til x:%n y:%n", 
      "if %b then": "hvis %b", 
      "pen up": "penn av", 
      "sensor %m.booleanSensor?": "sensor %m.booleanSensor?", 
      "%n mod %n": "%n mod %n", 
      "turn @turnLeft %n degrees": "vend @turnLeft %n grader", 
      "touching color %c?": "berører fargen %c?", 
      "mouse x": "mus x", 
      "mouse y": "mus y", 
      "item %d.listItem of %m.list": "element %d.listItem av %m.list", 
      "stop all sounds": "stopp all lyd", 
      "not %b": "ikke %b", 
      "next backdrop": "neste bakgrunn", 
      "set volume to %n%": "sett volum %n%", 
      "move %n steps": "gå %n steg", 
      "say %s for %n secs": "si %s i %n sekunder", 
      "backdrop name": "navn på bakgrunn", 
      "%m.list contains %s?": "%m.list inneholder %s?", 
      "days since 2000": "dager siden 2000", 
      "hide list %m.list": "skjul liste %m.list", 
      "set %m.effect effect to %n": "sett %m.effect effekt til %n", 
      "backdrop #": "bakgrunn #", 
      "play sound %m.sound until done": "spill lyden %m.sound til den er ferdig", 
      "set video transparency to %n%": "sett gjennomsiktighet av video til %n%", 
      "show list %m.list": "vis listen %m.list", 
      "touching %m.touching?": "berører %m.touching?", 
      "set %m.motor power to %n": "velg %m.motor styrke %n", 
      "color %c is touching %c?": "farge %c berører %c?", 
      "change pen size by %n": "endre pennbredde med %n", 
      "hide": "skjul", 
      "turn video %m.videoState": "sett video %m.videoState", 
      "set tempo to %n bpm": "sett tempo til %n slag i minuttet", 
      "hide variable %m.var": "skjul variabel %m.var", 
      "y position": "y-posisjon", 
      "rest for %n beats": "pause %n takter", 
      "turn @turnRight %n degrees": "vend @turnRight %n grader", 
      "play sound %m.sound": "spill lyden %m.sound", 
      "when %m.key key pressed": "når %m.key trykkes", 
      "tempo": "tempo", 
      "think %s": "tenk %s", 
      "when I receive %m.broadcast": "når jeg mottar %m.broadcast", 
      "switch costume to %m.costume": "bytt drakt til %m.costume", 
      "when tilt %m.eNe %n": "når helning %m.eNe %n", 
      "pen down": "penn på", 
      "go to %m.location": "gå til %m.location", 
      "point towards %m.spriteOrMouse": "pek mot %m.spriteOrMouse", 
      "distance to %m.spriteOrMouse": "avstand til %m.spriteOrMouse", 
      "timer": "klokke", 
      "set rotation style %m.rotationStyle": "begrens rotasjon %m.rotationStyle", 
      "switch backdrop to %m.backdrop": "bytt bakgrunn til %m.backdrop", 
      "loudness": "lydnivå", 
      "turn %m.motor on for %n secs": "start %m.motor i %n sekunder", 
      "add %s to %m.list": "legg %s til %m.list", 
      "replace item %d.listItem of %m.list with %s": "erstatt element %d.listItem i %m.list med %s", 
      "%m.mathOp of %n": "%m.mathOp av %n", 
      "when this sprite clicked": "når denne figuren klikkes", 
      "play drum %d.drum for %n beats": "trommeslag %d.drum som varer %n takter", 
      "set x to %n": "sett x til %n", 
      "size": "størrelse", 
      "set size to %n%": "sett størrelse til %n%", 
      "stamp": "stemple avtrykk", 
      "change size by %n": "endre størrelse med %n", 
      "set %m.var to %s": "sett %m.var til %s", 
      "set y to %n": "sett y til %n", 
      "%m.attribute of %m.spriteOrStage": "%m.attribute av %m.spriteOrStage", 
      "set pen shade to %n": "sett pennintensitet til %n", 
      "%b and %b": "%b og %b", 
      "username": "brukernavn", 
      "length of %s": "lengden av %s", 
      "direction": "retning", 
      "go back %n layers": "flytt bakover %n lag", 
      "%m.sensor sensor value": "%m.sensor sensorverdi", 
      "set instrument to %d.instrument": "velg instrument %d.instrument", 
      "else": "ellers", 
      "volume": "volum", 
      "round %n": "avrund %n", 
      "set %m.motor2 direction to %m.motorDirection": "velg %m.motor2 dreieretning %m.motorDirection", 
      "insert %s at %d.listItem of %m.list": "sett inn %s på plass %d.listItem i %m.list", 
      "distance": "avstand", 
      "broadcast %m.broadcast": "send melding %m.broadcast", 
      "video %m.videoMotionType on %m.stageOrThis": "video %m.videoMotionType på %m.stageOrThis", 
      "costume #": "drakt #", 
      "length of %m.list": "lengden av %m.list", 
      "go to front": "legg foran", 
      "change volume by %n": "endre volum med %n", 
      "when distance %m.lessMore %n": "når avstand %m.lessMore %n", 
      "delete this clone": "slett denne klonen", 
      "change y by %n": "endre y med %n", 
      "next costume": "neste drakt", 
      "letter %n of %s": "bokstav %n i %s", 
      "%b or %b": "%b eller %b", 
      "delete %d.listDeleteItem of %m.list": "slett %d.listDeleteItem i %m.list", 
      "when %m.sensor %m.lessMore %n": "når %m.sensor %m.lessMore %n", 
      "point in direction %d.direction": "pek i retning %d.direction", 
      "clear graphic effects": "ta bort grafiske effekter", 
      "join %s %s": "sett sammen %s %s", 
      "when %m.booleanSensor": "når %m.booleanSensor", 
      "change %m.var by %n": "endre %m.var med %n", 
      "when I start as a clone": "når jeg starter som klon", 
      "when %m.triggerSensor > %n": "når %m.triggerSensor > %n", 
      "end": "slutt", 
      "pick random %n to %n": "tilfeldig tall fra %n til %n", 
      "tilt": "helning", 
      "change tempo by %n": "endre tempo med %n", 
      "change pen color by %n": "endre pennfarge med %n", 
      "set pen size to %n": "sett pennbredde til %n", 
      "broadcast %m.broadcast and wait": "send melding %m.broadcast og vent", 
      "answer": "svar", 
      "change pen shade by %n": "endre pennintensitet med %n", 
      "wait %n secs": "vent %n sekunder", 
      "current %m.timeAndDate": "nåværende %m.timeAndDate", 
      "think %s for %n secs": "tenk %s i %n sekunder", 
      "change x by %n": "endre x med %n", 
      "glide %n secs to x:%n y:%n": "gli %n sekunder til x:%n y:%n", 
      "wait until %b": "vent til %b", 
      "x position": "x-posisjon", 
      "mouse down?": "museknappen er nede?", 
      "key %m.key pressed?": "tast %m.key trykket?", 
      "repeat %n": "gjenta %n ganger", 
      "if on edge, bounce": "sprett tilbake ved kanten", 
      "forever": "for alltid", 
      "ask %s and wait": "spør %s og vent", 
      "clear": "slett", 
      "create clone of %m.spriteOnly": "lag klon av %m.spriteOnly", 
      "reset timer": "nullstill klokka", 
      "when backdrop switches to %m.backdrop": "når bakgrunn bytter til %m.backdrop", 
      "stop %m.stop": "stopp %m.stop", 
      "when @greenFlag clicked": "når @greenFlag klikkes"
    }, 
    "osis": [
      "andre skript på scenen", 
      "andre skript i figuren"
    ], 
    "ignorelt": [
      null
    ], 
    "dropdowns": {
      "C connected": "C tilkoblet", 
      "all": "alle", 
      "other scripts in sprite": "andre skript i figuren", 
      "color": "farge", 
      "year": "år", 
      "mouse-pointer": "musepeker", 
      "month": "måned", 
      "B connected": "B tilkoblet", 
      "second": "sekund", 
      "up arrow": "pil opp", 
      "don't rotate": "ikke roter", 
      "pixelate": "piksel", 
      "fisheye": "fiskeøye", 
      "resistance-D": "motstand-D", 
      "whirl": "virvel", 
      "resistance-A": "motstand-A", 
      "previous backdrop": "forrige bakgrunn", 
      "resistance-C": "motstand-C", 
      "sound": "lyd", 
      "mosaic": "mosaikk", 
      "A connected": "A tilkoblet", 
      "that way": "mot klokken", 
      "Stage": "Scene", 
      "left-right": "vend sideveis", 
      "left arrow": "pil venstre", 
      "video motion": "videobevegelse", 
      "this way": "med klokken", 
      "day of week": "ukedag", 
      "right arrow": "pil høyre", 
      "slider": "skyveknapp", 
      "D connected": "D tilkoblet", 
      "this script": "dette skriptet", 
      "date": "dato", 
      "all around": "fri rotasjon", 
      "minute": "minutt", 
      "reverse": "baklengs", 
      "ghost": "gjennomsiktig", 
      "on": "på", 
      "myself": "meg", 
      "off": "av", 
      "resistance-B": "motstand-B", 
      "hour": "time", 
      "brightness": "lysstyrke", 
      "button pressed": "knapp trykket", 
      "light": "lys", 
      "random position": "tilfeldig sted", 
      "space": "mellomrom", 
      "this sprite": "denne figuren", 
      "down arrow": "pil ned", 
      "on-flipped": "på-speilvendt", 
      "costume name": "draktnavn", 
      "motion": "bevegelse", 
      "edge": "kant"
    }, 
    "define": [
      "definer"
    ], 
    "palette": {
      "Sound": "Lyd", 
      "Control": "Styring", 
      "More Blocks": "Flere klosser", 
      "Sensing": "Sansning", 
      "variables": null, 
      "Operators": "Operatorer", 
      "list": "liste", 
      "lists": null, 
      "Motion": "Bevegelse", 
      "Pen": "Penn", 
      "Looks": "Utseende", 
      "variable": "variabel", 
      "Tips": "Hjelp", 
      "Data": "Data", 
      "Events": "Hendelser"
    }, 
    "math": [
      "10 ^", 
      "cos", 
      "log", 
      "arcsin", 
      "kvadratrot", 
      "arctan", 
      "e ^", 
      "ln", 
      "abs", 
      "gulv", 
      "arccos", 
      "tan", 
      "sin", 
      "tak"
    ], 
    "aliases": {
      "vend venstre %n grader": "turn @turnLeft %n degrees", 
      "vend høyre %n grader": "turn @turnRight %n degrees", 
      "når grønt flagg klikkes": "when @greenFlag clicked"
    }
  }
});